import type { GridOptions } from "ag-grid-community";
import { themeQuartz } from "ag-grid-community";

/**
 * Creates a custom AG Grid theme with column borders (vertical separators)
 * This is just like the tables we have right now
 */
export const agGridTheme = themeQuartz.withParams({
  fontSize: 12,
  columnBorder: true,
  headerColumnBorder: true,
  headerFontWeight: 700,
  rowVerticalPaddingScale: 2,
  browserColorScheme: "light",
});

/**
 * Common AG Grid configuration
 */
export const defaultGridOptions: Partial<GridOptions> = {
  suppressCellFocus: true,
  theme: agGridTheme,
  defaultColDef: {
    sortable: true,
    filter: false,
    resizable: false,
    cellStyle: {
      alignItems: "center",
    },
  },
  cacheQuickFilter: true,
  rowHeight: 50,
  headerHeight: 50,
  suppressMenuHide: true,
  domLayout: "normal",
  suppressHorizontalScroll: false,
};
